import { call, put, takeEvery } from "redux-saga/effects";
import {
  accessTokenAction,
  getAffiliateDetailsAction,
  loginAction,
  logoutAction,
} from "../../api/auth/authAction";
import {
  getToken,
  setError,
  setIsLoggedin,
  setUser,
} from "../../redux/auth/auth-slice";
import { toast } from "react-toastify";

export function* loginSaga(action) {
  try {
    yield put(
      setIsLoggedin({
        isLoggedin: true,
      })
    );
    const response = yield call(loginAction, action.payload);
    console.log(response, "<-------response login auth-Slice");

    if (response.status === 200) {
      yield put(setError({ errmsg: "" }));
      localStorage.setItem("affiliateEmail", action.payload.body.username);
      yield put({
        type: "AUTH_ACCESS_TOKEN",
        payload: { affiliateEmail: action.payload.body.username },
      });

      toast.success(response.data.message);

      yield put(
        setIsLoggedin({
          isLoggedin: false,
        })
      );
    }
  } catch (error) {
    // console.log(error);
    toast.error(error?.response?.data?.message);
    yield put(
      setIsLoggedin({
        isLoggedin: false,
      })
    );
    yield put(setError({ errmsg: error?.response?.data?.message }));
  }
}

export function* accessTokenSaga(action) {
  try {
    const response = yield call(accessTokenAction, action.payload);
    console.log(response, "response");

    if (response.status === 200) {
      yield put(
        getToken({
          token: response?.data?.accessToken,
        })
      );

      localStorage.setItem("isLoggedin", true);

      console.log("access token");
    }
  } catch (error) {
    toast.error(error?.response?.data?.message);
    yield put(setError({ errmsg: error?.response?.data?.message }));
  }
}

export function* logoutSaga(actions) {
  try {
    localStorage.removeItem("affiliateEmail");
    const response = yield call(logoutAction, actions.payload);

    if (response.status === 200) {
      localStorage.removeItem("isLoggedin");

      yield put(
        getToken({
          token: "",
        })
      );
      actions.payload.navigate("/login");
    }
  } catch (error) {
    console.log(error, "error from logout saga");
  }
}

export function* getAffiliateDetails(action) {
  try {
    const response = yield getAffiliateDetailsAction(action.payload);
    // console.log(response, "response from affiliate saga");

    if (response.status === 200) {
      yield put(
        setUser({
          user: response?.data?.affiliateDetails,
        })
      );
    }
  } catch (error) {
    toast.error(error?.response?.data?.message);
  }
}

export function* watchLoginSaga() {
  yield takeEvery("AUTH_LOGIN", loginSaga);
  yield takeEvery("AUTH_ACCESS_TOKEN", accessTokenSaga);
  yield takeEvery("AFFILIATE_DETAILS", getAffiliateDetails);
  yield takeEvery("AUTH_LOGOUT", logoutSaga);
}
